import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

//
import { Card } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import Moment from "react-moment";

function RadialChart({ title, data }) {
  const [key, setKey] = useState(0);
  const [option, setOption] = useState({
    chart: {
      type: "radialBar",
      toolbar: {
        show: false,
      },
      offsetY: -18,
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -100,
        endAngle: 100,
        hollow: {
          margin: 0,
          size: "80%",
          background: "transparent",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: false,
          },
        },
        track: {
          background: "#F7F8FA",
          strokeWidth: "80%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: false,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },

        dataLabels: {
          show: true,
          name: {
            offsetY: 25,
            show: true,
            color: "#2FDB9D",
            fontSize: "18px",
            lineHeigth: "25.2px",
          },
          value: {
            offsetY: -20,
            show: true,
            color: "#2FDB9D",
            fontSize: "18px",
            lineHeigth: "25.2px",
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#FFD231", "#97D667"],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },


    colors: ["#97D667"],
    labels: [""],
    series: [0],
  });

  /**
   * Convert Title To Color
   */
  const convertTitleToColor = (title) => {
    if (title === "Extreme Greed") return "#2fc6db";
    if (title === "Greed") return "#2FDB9D";
    if (title === "Fear") return "#f9a643";
    if (title === "Extreme Fear") return "#F64A4A";
    if(title === "Neutral") return '#dfce60'
  };

  const setChartData = () => {
    if (data.value) {
      let chart = { ...option };

      chart.series = [data.value];
      chart.labels = [data.value_classification];
  
      // strock color
      let color = convertTitleToColor(data.value_classification)
      chart.colors = [color]

      // label color
      chart.plotOptions.radialBar.dataLabels.name.color = color

      // value color
      chart.plotOptions.radialBar.dataLabels.value.color = color
  
      setOption(chart);
  
      setKey(key + 1);
    }
  }

  useEffect(() => {
    setChartData()
  }, [data]);

  return (
    <Card className="radial-chart">
      <Card.Header className="no-border text-black text-center">
        {title}
      </Card.Header>

      <Card.Body>
        <ReactApexChart
          key={key}
          options={option}
          series={option.series}
          type="radialBar"
          height={290}
        />
        <div className="chart-info">
          <small className="time">
            <i className="las la-sync" />
            <span>last updated</span>
            <Moment utc unix format="MMM DD">
              {data.timestamp}
            </Moment>
            <span>at</span>
            <Moment utc unix format="h:mm A">
              {data.timestamp}
            </Moment>
          </small>
        </div>
      </Card.Body>
    </Card>
  );
}

RadialChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default RadialChart;
